var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"canvas-background",attrs:{"id":"canvas-background"}}),_c('admin-header'),_c('router-view'),_c('admin-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }